export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'component.AudioUploader.index.t0': '上传中',
  'component.AudioUploader.index.t1': '上传',
  'component.AudioUploader.index.t2': '请求失败，请稍后重试',
  'component.AutoUploader.index.t0': '上传图片',
  'component.AutoUploader.index.t1': '请求失败，请稍后重试',
  'component.AutoUploader.index.t2': '暂无图片',
  'component.DetectItem.index.t0': '收缩压（高压）',
  'component.DetectItem.index.t1': '舒张压（低压）',
  'component.DetectItem.index.t2': '心率',
  'component.DetectItem.index.t3': '血糖',
  'component.DetectItem.index.t4': '血氧',
  'component.DetectItem.index.t5': '体温',
  'component.DetectItem.index.t6': '无',
  'component.DoubleCallModal.index.t0': '呼叫成功',
  'component.DoubleCallModal.index.t1': '呼叫失败',
  'component.DoubleCallModal.index.t2': '拨打电话',
  'component.DoubleCallModal.index.t3': '客户电话',
  'component.DoubleCallModal.index.t4': '请输入客户电话号码',
  'component.DoubleCallModal.index.t5': '我的电话',
  'component.DoubleCallModal.index.t6': '请输入电话号码',
  'component.DraggableModal.index.t0': '提示',
  'component.Editor.index.t0': '图片上传失败，请稍后重试',
  'component.Exception.index.t0': '抱歉，你访问的页面不存在',
  'component.Exception.index.t1': '返回首页',
  'component.Exception.index.t2': '抱歉，你无权访问该页面',
  'component.Exception.index.t3': '返回首页',
  'component.Footer.index.t0': '蓝熙健康管理有限公司',
  'component.Form.CreateForm.t0': '新建规则',
  'component.Form.UpdateForm.t0': '监控对象',
  'component.Form.UpdateForm.t1': '表一',
  'component.Form.UpdateForm.t2': '表二',
  'component.Form.UpdateForm.t3': '规则模板',
  'component.Form.UpdateForm.t4': '规则模板一',
  'component.Form.UpdateForm.t5': '规则模板二',
  'component.Form.UpdateForm.t6': '规则类型',
  'component.Form.UpdateForm.t7': '强',
  'component.Form.UpdateForm.t8': '弱',
  'component.Form.UpdateForm.t9': '开始时间',
  'component.Form.UpdateForm.t10': '请选择开始时间！',
  'component.Form.UpdateForm.t11': '选择开始时间',
  'component.Form.UpdateForm.t12': '调度周期',
  'component.Form.UpdateForm.t13': '月',
  'component.Form.UpdateForm.t14': '周',
  'component.Form.UpdateForm.t15': '规则名称',
  'component.Form.UpdateForm.t16': '请输入规则名称！',
  'component.Form.UpdateForm.t17': '请输入',
  'component.Form.UpdateForm.t18': '规则描述',
  'component.Form.UpdateForm.t19': '请输入至少五个字符的规则描述！',
  'component.Form.UpdateForm.t20': '请输入至少五个字符',
  'component.Form.UpdateForm.t21': '上一步',
  'component.Form.UpdateForm.t22': '取消',
  'component.Form.UpdateForm.t23': '下一步',
  'component.Form.UpdateForm.t24': '上一步',
  'component.Form.UpdateForm.t25': '取消',
  'component.Form.UpdateForm.t26': '完成',
  'component.Form.UpdateForm.t27': '取消',
  'component.Form.UpdateForm.t28': '下一步',
  'component.Form.UpdateForm.t29': '规则配置',
  'component.Form.UpdateForm.t30': '基本信息',
  'component.Form.UpdateForm.t31': '配置规则属性',
  'component.Form.UpdateForm.t32': '设定调度周期',
  'component.HeaderContent.index.t0': '刷新当前页面',
  'component.HeaderContent.index.t1': '关闭当前标签',
  'component.HeaderContent.index.t2': '关闭右侧',
  'component.HeaderContent.index.t3': '关闭左侧',
  'component.HeaderContent.index.t4': '关闭全部',
  'component.HeaderContent.index.t5': '无法被关闭',
  'component.HeaderContent.index.t6': '右侧没有标签',
  'component.HeaderContent.index.t7': '左侧没有标签',
  'component.Inquiry.InquiryCountdown.t0': '咨询中',
  'component.Inquiry.InquiryCountdown.t1': '分钟',
  'component.Inquiry.InquiryCountdown.t2': '秒',
  'component.Inquiry.InquiryCountdown.t3': '后咨询结束',
  'component.Inquiry.InquiryDropdown.t0': '设为',
  'component.Inquiry.InquiryDropdown.t1': '离线',
  'component.Inquiry.InquiryDropdown.t2': '在线',
  'component.Inquiry.InquiryDropdown.t3': '咨询服务台',
  'component.Inquiry.InquiryDropdown.t4': '查看客户在线咨询消息，及时回复客户',
  'component.Inquiry.InquiryDropdown.t5': '连接',
  'component.Inquiry.InquiryDropdown.t6': '咨询服务台',
  'component.Inquiry.InquiryHeader.t0': '客户信息',
  'component.Inquiry.InquiryHeader.t1': '年龄：',
  'component.Inquiry.InquiryHeader.t2': '岁',
  'component.Inquiry.InquiryHeader.t3': '性别：',
  'component.Inquiry.InquiryHeader.t4': '手机号：',
  'component.Inquiry.InquiryList.t0': '图片',
  'component.Inquiry.InquiryList.t1': '语音',
  'component.Inquiry.InquiryList.t2': '未知的消息类型',
  'component.Inquiry.InquiryList.t3': '对话列表',
  'component.Inquiry.InquiryList.t4': '待接诊',
  'component.Inquiry.InquiryList.t5': '待接诊',
  'component.Inquiry.InquiryMessage.t0': '聊天图片',
  'component.Inquiry.InquiryMessage.t1': '您的浏览器不支持音频播放，建议您使用谷歌浏览器',
  'component.Inquiry.InquiryMessage.t2': '未知的消息类别',
  'component.Inquiry.InquiryRecordList.t0': '我',
  'component.Inquiry.InquirySender.t0': '请输入内容',
  'component.Inquiry.InquirySender.t1': '结束咨询',
  'component.Inquiry.InquirySender.t2': '时间未到，是否马上结束咨询？',
  'component.Inquiry.InquirySender.t3': 'Enter 发送，Shift+Enter 换行',
  'component.Maps.TMap.t0': '地址：',
  'component.Maps.TMap.t1': '地址：',
  'component.Maps.TMap.t2': '请输入',
  'component.Maps.TMap.t3': '共{total}条结果',
  'component.Maps.TMap.t4': '展开',
  'component.Maps.TMap.t5': '收起',
  'component.Maps.TMap.t6': '地址：',
  'component.MessageCenter.index.t0': '全部',
  'component.MessageCenter.index.t1': '公告',
  'component.MessageCenter.index.t2': '通知',
  'component.MessageCenter.index.t3': '通知',
  'component.MessageCenter.index.t4': '公告',
  'component.MessageCenter.index.t5': '任务创建通知',
  'component.MessageCenter.index.t6': '任务完成通知',
  'component.MessageCenter.index.t7': '任务关闭通知',
  'component.MessageCenter.index.t8': '任务修改通知',
  'component.MessageCenter.index.t9': '任务转交通知',
  'component.MessageCenter.index.t10': '任务处理通知',
  'component.MessageCenter.index.t11': '新客户提醒',
  'component.MessageCenter.index.t12': '任务处理提醒',
  'component.MessageCenter.index.t13': '全部',
  'component.MessageCenter.index.t14': '全部',
  'component.MessageCenter.index.t15': '删除',
  'component.MessageCenter.index.t16': '确认要删除该条消息？',
  'component.MessageCenter.index.t17': '删除',
  'component.MessageCenter.index.t18': '确认要删除所有已读消息？',
  'component.MessageCenter.index.t19': '提示',
  'component.MessageCenter.index.t20': '确认要将所有消息设为已读吗？',
  'component.MessageCenter.index.t21': '查看所有消息',
  'component.MessageCenter.index.t22': '仅看未读消息',
  'component.MessageCenter.index.t23': '标记所有为已读',
  'component.MessageCenter.index.t24': '删除所有已读消息',
  'component.MessageCenter.index.t25': '任务概括',
  'component.MessageCenter.index.t26': '服务项目',
  'component.MessageCenter.index.t27': '任务来源',
  'component.MessageCenter.index.t28': '任务创建者',
  'component.MessageCenter.index.t29': '任务转交者',
  'component.MessageCenter.index.t30': '实际执行者',
  'component.MessageCenter.index.t31': '实际执行时间',
  'component.MessageCenter.index.t32': '计划执行者',
  'component.MessageCenter.index.t33': '计划执行时间',
  'component.MessageCenter.index.t34': '任务描述',
  'component.MessageCenter.index.t35': '查看更多详情',
  'component.MessageCenter.index.t36': '查看所有信息，及时处理任务',
  'component.MessageCenter.index.t37': '消息中心',
  'component.MessageCenter.index.t38': '全部',
  'component.MessageCenter.index.t39': '全部',
  'component.MessageCenter.index.t40': '公告',
  'component.MessageCenter.index.t41': '公告',
  'component.MessageCenter.index.t42': '公告',
  'component.MessageCenter.index.t43': '通知',
  'component.MessageCenter.index.t44': '通知',
  'component.MessageCenter.index.t45': '通知',
  'component.MessageCenter.index.t46': '通知',
  'component.NoticeIcon.index.t0': '清空了',
  'component.NoticeIcon.index.t1': '清空',
  'component.NoticeIcon.index.t2': '查看更多',
  'component.NoticeIcon.index.t3': '通知',
  'component.NoticeIcon.index.t4': '你已查看所有通知',
  'component.NoticeIcon.index.t5': '消息',
  'component.NoticeIcon.index.t6': '您已读完所有消息',
  'component.NoticeIcon.index.t7': '待办',
  'component.NoticeIcon.index.t8': '你已完成所有待办',
  'component.RightContent.AvatarDropdown.t0': '编辑信息',
  'component.RightContent.AvatarDropdown.t1': '修改密码',
  'component.RightContent.AvatarDropdown.t2': '个人中心',
  'component.RightContent.AvatarDropdown.t3': '个人设置',
  'component.RightContent.AvatarDropdown.t4': '退出登录',
  'component.GlobalHeaderRight.index.t0': '正在更新',
  'component.GlobalHeaderRight.index.t1': '更新用户信息失败请重试！',
  'component.GlobalHeaderRight.index.t2': '正在设置',
  'component.GlobalHeaderRight.index.t3': '设置成功',
  'component.GlobalHeaderRight.index.t4': '设置失败请重试！',
  'component.GlobalHeaderRight.index.t5': '查看帮助文档，快速熟悉系统',
  'component.GlobalHeaderRight.index.t6': '帮助文档',
  'component.GlobalHeaderRight.index.t7': '修改个人信息',
  'component.GlobalHeaderRight.index.t8': '上传中',
  'component.GlobalHeaderRight.index.t9': '上传成功',
  'component.GlobalHeaderRight.index.t10': '上传失败，请稍后重试',
  'component.GlobalHeaderRight.index.t11': '员工姓名',
  'component.GlobalHeaderRight.index.t12': '请输入姓名！',
  'component.GlobalHeaderRight.index.t13': '登录名',
  'component.GlobalHeaderRight.index.t14': '请输入登录名！',
  'component.GlobalHeaderRight.index.t15': '联系电话',
  'component.GlobalHeaderRight.index.t16': '请输入正确的手机/固话号码！',
  'component.GlobalHeaderRight.index.t17': '更换头像',
  'component.GlobalHeaderRight.index.t18': '上传照片',
  'component.GlobalHeaderRight.index.t19': '修改密码',
  'component.GlobalHeaderRight.index.t20': '请设置正确的密码格式！',
  'component.GlobalHeaderRight.index.t21': '请输入新密码！',
  'component.GlobalHeaderRight.index.t22': '请输入新密码！',
  'component.GlobalHeaderRight.index.t23': '注：密码长度需大于6位（含），支持输入字母、数字和字符，且必须包含2项以上。设置成功后需重新登录。',
  'component.GlobalHeaderRight.index.t24': '修改信息',
  'component.GlobalHeaderRight.index.t25': '退出登录',
  'component.GlobalHeaderRight.index.t26': '保存',
  'component.GlobalHeaderRight.index.t27': '修改失败，请稍后重试',
  'component.GlobalHeaderRight.index.t28': '修改失败，请稍后重试',
  'component.GlobalHeaderRight.index.t29': '联系电话',
  'component.GlobalHeaderRight.index.t30': '请输入手机号',
  'component.GlobalHeaderRight.index.t31': '请输入正确的手机/固话号码！',
  'component.GlobalHeaderRight.index.t32': '验证码',
  'component.GlobalHeaderRight.index.t33': '验证码',
  'component.GlobalHeaderRight.index.t34': '获取验证码',
  'component.GlobalHeaderRight.index.t35': '获取验证码',
  'component.GlobalHeaderRight.index.t36': '请输入验证码！',
  'component.GlobalHeaderRight.index.t37': '获取验证码成功！',
  'component.GlobalHeaderRight.index.t38': '获取验证码失败，请稍后再试',
  'component.GlobalHeaderRight.index.t39': '获取验证码失败，请稍后再试',
  'component.GlobalHeaderRight.index.t40': '新密码',
  'component.GlobalHeaderRight.index.t41': '请输入新密码',
  'component.GlobalHeaderRight.index.t42': '请设置正确的密码格式！',
  'component.GlobalHeaderRight.index.t43': '注：密码长度需大于6位（含），支持输入字母、数字和字符，且必须包含2项以上。设置成功后需重新登录。',
  'component.GlobalHeaderRight.index.t44': '请输入正确的手机号码或固定电话，固定电话格式为“区号+号码”',
  'component.GlobalHeaderRight.index.t45': '如01088888888，中间无需标点符号连接。',
  'component.GlobalHeaderRight.index.t46': '请输入',
  'component.GlobalHeaderRight.index.t47': '请输入正确格式的联系电话',
  'component.GlobalHeaderRight.index.t48': '两次密码不一致',
  'component.GlobalHeaderRight.index.t49': '旧密码',
  'component.GlobalHeaderRight.index.t50': '新密码',
  'component.GlobalHeaderRight.index.t51': '确认密码',
  'component.GlobalHeaderRight.index.t52': '请获取验证码',
  'component.RightContent.MessageNotice.t0': '查看',
  'component.RightContent.MessageNotice.t1': '新任务提醒',
  'component.RightContent.MessageNotice.t2': '您收到一条新任务，点击查看吧',
  'component.RightContent.MenuSearch.t0': '站内搜索',
  'component.Uploader.index.t0': '上传',
  'component.Uploader.index.t1': '上传失败',
  'component.VideoUploader.index.t0': '请上传视频',
  'component.VideoUploader.index.t1': '视频正在上传中',
  'component.VideoUploader.index.t2': '点击上传',
  'component.VideoUploader.index.t3': '仅支持mp4格式的视频文件上传',
  'component.ImportFileModal.index.t1': '导入',
  'component.ImportFileModal.index.t2': '总计导入：',
  'component.ImportFileModal.index.t3': '导入失败：',
  'component.ImportFileModal.index.t44': '失败数据：',
  "components.LocaleModifyComp.index.t0": "修改国际化配置",
  "components.LocaleModifyComp.index.t1": "确认修改吗？",
  "components.LocaleModifyComp.index.t2": "序号",
  "components.LocaleModifyComp.index.t3": "修改前",
  "components.LocaleModifyComp.index.t4": "修改后",
  "components.LocaleModifyComp.index.t5": "输入框不能为空！",
  "components.LocaleModifyComp.index.t6": "输入关键词查找",
};
